/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { BasicRoutes } from '../../constants/basicRoutes';
import { Namespaces } from '../../i18n';
import { INotification } from '../../store/notifications/types';
import { AppStandaloneEvents } from '../../types/common/AppEvents';
import { NotificationItemFrameOptions } from '../../types/notification/NotificationItemFrameOptions';
import { useNotificationRelativeDate } from '../../utils/useNotificationRelativeDate';
import { NotificationItemFrame } from '../NotificationItemFrame/NotificationItemFrame';

type SeeInvitationsNotificationProps = NotificationItemFrameOptions & {
  notification: INotification<AppStandaloneEvents.SeeInvitations>;
};

export function SeeInvitationsNotification(props: SeeInvitationsNotificationProps) {
  const { notification, asSnackbar, onRootClick, ...frameProps } = props;
  const { t } = useTranslation([Namespaces.Navigation]);
  const navigate = useNavigate();
  const { createdAt, isRead, event } = notification;
  const [datetime] = useNotificationRelativeDate(createdAt);

  const onClick = () => {
    onRootClick && onRootClick({ id: notification.id });
    void navigate(BasicRoutes.ORGANIZATIONS);
  };

  return (
    <NotificationItemFrame
      {...frameProps}
      onRootClick={onClick}
      datetime={datetime}
      isRead={asSnackbar ? true : isRead}
      primaryText={t('notifications.templates.you_have_pending_invitations')}
      secondaryText={t('notifications.templates.count_invitations', {
        count: event.count,
      })}
      id={notification.id}
      asSnackbar={asSnackbar}
    />
  );
}
